// The app's one sign-in session (@jkast90/kast-common/auth): its tokens in
// the auth_* localStorage keys every kast-dev app uses, refreshed before they
// expire and once on a 401, revoked on sign-out. Created on import, before the
// first render, so the first frame and the first request already have it.

import {
  createSession,
  displayEmail,
  localStorageTokenStore,
} from "@jkast90/kast-common/auth";
import { STORAGE_KEYS } from "../_common/constants";
import { clearUserData } from "../_common/auth/clearUserData";
import { getCognitoClientId, getCognitoDomain } from "../_common/settings";

export const session = createSession({
  cognitoDomain: getCognitoDomain(),
  clientId: getCognitoClientId(),
  store: localStorageTokenStore({ alsoClear: [STORAGE_KEYS.USER_EMAIL] }),
});

// Pages still read the signed-in email from localStorage ("userEmail"), as
// they did before the module; the store clears it with the tokens. A session
// that ends (a sign-out, including one that leaves the page, a rejected
// refresh, an expiry, a sign-out in another tab) also drops what this user
// left in the browser.
function onSessionChange(): void {
  const { status, user, endedBy } = session.getState();
  if (status === "signedIn") {
    const email = displayEmail(user);
    try {
      if (email) localStorage.setItem(STORAGE_KEYS.USER_EMAIL, email);
    } catch {
      // Storage blocked: the Redux mirror still has the email.
    }
  } else if (status === "signedOut" && endedBy) {
    clearUserData();
  }
}
onSessionChange();
session.subscribe(onSessionChange);
